<template>
  <div id="app">
    <!-- <HelloWorld msg="Welcome to Your Vue.js App"/> -->
    <router-view></router-view>
  </div>
</template>

<script>

export default {
  name: 'app',

}
</script>

<style>
#app {
  font-family: 'Almarai', sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  height: 100vh;
}
body {
  font-size: 16px !important;
}
.main-div {
  float: right;
  width: 80%;
  right: 0;
  top: 0;
}
.component-container {
  display: block !important;
}
.modified-dropdown {
  -webkit-appearance: menulist !important;
  background: none !important;
}
</style>
